module.exports = __webpack_public_path__ + "static/media/carrito.f36b10c2.svg";